import React, { useEffect, useState } from "react";
import { FateFormula, FateFormulaRequest } from "../../types/types";
import { FateFormulaService } from "../../services/fateFormulaService";
import { useToast } from "../../components/ui";
import { PageContainer, PageHeader } from "../../components/layout";
import FateFormulaLibrary from "../../components/business/FateFormula/FateFormulaLibrary";

const FateFormulaLibraryPage: React.FC = () => {
  const toast = useToast();
  const [formulas, setFormulas] = useState<FateFormula[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchFormulas = async (s: string) => {
    setLoading(true);
    try {
      const data = await FateFormulaService.listUser(s || undefined);
      setFormulas(data);
    } catch {
      toast.showToast({ type: "error", message: "Failed to load fate formulas." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const id = setTimeout(() => fetchFormulas(search), 300);
    return () => clearTimeout(id);
  }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCreate = async (req: FateFormulaRequest) => {
    await FateFormulaService.createUser(req);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula created." });
  };

  const handleUpdate = async (id: number, req: FateFormulaRequest) => {
    await FateFormulaService.updateUser(id, req);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula updated." });
  };

  const handleDelete = async (id: number) => {
    await FateFormulaService.deleteUser(id);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula deleted." });
  };

  return (
    <PageContainer maxWidth="full">
      <PageHeader title="Fate Formulas" />
      <FateFormulaLibrary
        formulas={formulas}
        search={search}
        onSearch={setSearch}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        loading={loading}
      />
    </PageContainer>
  );
};

export default FateFormulaLibraryPage;
